/* eslint-disable @typescript-eslint/no-explicit-any */
import type { DocumentNode, FieldNode, OperationDefinitionNode } from 'graphql';

export default function getDataFromMutationResult<ExpectedData = any>(
  document: DocumentNode,
  result: any,
): ExpectedData | null | undefined {
  if (!result || !result.data) {
    return undefined;
  }

  // find name of operation selection
  const operation = document.definitions.find(
    def => def.kind === 'OperationDefinition',
  ) as OperationDefinitionNode | undefined;

  const selections = operation?.selectionSet.selections.filter(
    def => def.kind === 'Field',
  );
  if (selections?.length !== 1) {
    throw new Error('expects one selection in document');
  }
  const selection = selections[0] as FieldNode;

  if (!selections) {
    throw new Error('no operation name found in document');
  }

  const operationName = selection.name.value as keyof Record<
    string,
    ExpectedData
  >;

  return result.data[operationName] as ExpectedData;
}
